import Service from '@/helpers/service'

export default {
    get(page, params) {
        return Service().get('ABCIndicator?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('ABCIndicator/show/'+id);
    },    
    create(params) {
        return Service().post('ABCIndicator/create', params);
    },
    update(id, params) {
        return Service().post('ABCIndicator/update/'+id, params);
    },
    delete(id) {
        return Service().post('ABCIndicator/delete/'+id);
    }
}